module.exports = require("./sw-UG.d.ts");